var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.075 0C12.9445 0 13.65 0.713535 13.65 1.59375V3.1875H15.3136C15.8714 3.1875 16.3767 3.40996 16.8 3.8084L19.3364 6.375C19.7302 6.77344 19.95 7.31465 19.95 7.8791V11.6875C20.5308 11.6875 21 12.1623 21 12.75C21 13.3377 20.5308 13.8125 19.95 13.8125H18.9C18.9 15.5723 17.4891 17 15.75 17C13.9814 17 12.6 15.5723 12.6 13.8125H8.4C8.4 15.5723 6.98906 17 5.25 17C3.48141 17 2.1 15.5723 2.1 13.8125H1.575C0.705141 13.8125 0 13.0986 0 12.2188V1.59375C0 0.713535 0.705141 0 1.575 0H12.075ZM13.65 5.3125V8.5H17.85V7.8791L15.3136 5.3125H13.65ZM5.25 12.2188C4.38047 12.2188 3.675 12.9326 3.675 13.8125C3.675 14.6924 4.38047 15.4062 5.25 15.4062C6.11953 15.4062 6.825 14.6924 6.825 13.8125C6.825 12.9326 6.11953 12.2188 5.25 12.2188ZM15.75 15.4062C16.6195 15.4062 17.325 14.6924 17.325 13.8125C17.325 12.9326 16.6195 12.2188 15.75 12.2188C14.8805 12.2188 14.175 12.9326 14.175 13.8125C14.175 14.6924 14.8805 15.4062 15.75 15.4062Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.2d5225437b6264521ae471c776ba872b.svg";
export { ForwardRef as ReactComponent };